import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Col, ConfigProvider, Divider, Row, Table, Tabs, Spin } from 'antd';
import classNames from 'classnames/bind';
import moment from 'moment';
import { useEffect, useState } from 'react';
import offerAPI from '~/api/OfferAPI';
import EmptyForm from '~/components/Empty';
import Wallet from '~/components/Wallet';
import { getNumberWithCommas } from '~/utils';
import CardAboutMe from '../../components/card-about-me';
import styles from './HistoryTopUp.module.scss';
import styled from 'styled-components';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { LeftOutlined } from '@ant-design/icons';
import config from '~/config';
import { useNavigate } from 'react-router-dom';
import { SVGS } from '~/assets/assetsPath';

const { TabPane } = Tabs;
const cx = classNames.bind(styles);

const TableCustom = styled.div`
    width: 100%;
    .ant-table-body {
        &::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        /* Track */
        &::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px grey;
            border-radius: 10px;
        }
        /* Handle */
        &::-webkit-scrollbar-thumb {
            background: var(--main-color);
            border-radius: 10px;
        }
        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
            // background: var(--main-color-hover);
        }
    }
    @media screen and (max-width: 480px) {
        display: none;
    }
`;
const TabsContainer = styled.div`
    .ant-tabs-tab {
        font-size: 16px;
        font-weight: 600;
        color: rgba(137, 137, 137, 1);
    }
    .ant-tabs-tab.ant-tabs-tab-active {
        border-bottom: 3px solid #311d4f !important;
        z-index: 2;
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #311d4f;
    }
    .ant-tabs > .ant-tabs-nav,
    .ant-tabs > div > .ant-tabs-nav {
        margin: 0px 30px;
        @media screen and (max-width: 480px) {
            margin: 0px 10px;
        }
    }
    .ant-tabs-bottom > .ant-tabs-nav:before,
    .ant-tabs-bottom > div > .ant-tabs-nav:before,
    .ant-tabs-top > .ant-tabs-nav:before,
    .ant-tabs-top > div > .ant-tabs-nav:before {
        border-bottom: 3px solid #e2e2e2;
    }
`;

const renderSign = (type, status_enum) => {
    switch (type) {
        case 'REFUND':
            return '+';

        case 'ROSES':
            return '+';
        case 'ROSES_MONTHLY':
            return '+';

        case 'WITHDRAW':
            return '-';
        case 'REQUEST_WITHDRAW':
            return '';
        case 'REJECTED_REQUEST_WITHDRAW':
            return '+';
        case 'APPROVED_REQUEST_WITHDRAW':
            return '-';

        case 'DISCOUNT_FOR_CLIENT_HIDDEN':
            return '+';

        case 'DEPOSIT':
            return '+';
        case 'REJECTED_REQUEST_DEPOSIT':
            return '';
        case 'APPROVED_REQUEST_DEPOSIT':
            return '+';
        case 'REQUEST_DEPOSIT': {
            switch (status_enum) {
                case 'CANCEL':
                    return '';
                case 'DONE':
                    return '+';
                case 'PENDING':
                    return '';
                default:
                    return '';
            }
        }
        default:
            return '';
    }
};
const HistoryTopUp = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [showAmount, setShowAmount] = useState(false);
    const [historyTopUp, setHistoryTopUp] = useState([]);
    const [activeKey, setActiveKey] = useState('');

    const getValueRecord = (item) => {
        if (item.type === 'REQUEST_WITHDRAW' || item.type === 'REJECTED_REQUEST_WITHDRAW') {
            return item.original_value;
        } else {
            return item.change_amount;
        }
    };

    const columnsDeposit = [
        {
            title: () => {
                return <div style={{ fontSize: '16px', fontWeight: '600', color: '#311d4f' }}>Transaction</div>;
            },
            // dataIndex: 'note_admin',
            width: '30%',
            render: (item, record) => (
                <div
                    style={{
                        fontWeight: '600',
                    }}
                >
                    {record.note_admin}
                </div>
            ),
        },
        {
            title: () => {
                return <div style={{ fontSize: '16px', fontWeight: '600', color: '#311d4f' }}>Time</div>;
            },
            dataIndex: 'created_at_unix_timestamp',
            align: 'center',
            width: '30%',
            render: (item) => (
                <div
                    style={{
                        color: 'rgba(137, 137, 137, 1)',
                    }}
                >
                    {moment(item, 'x').format('HH:mm, DD/MM/YYYY')}
                </div>
            ),
        },
        {
            title: () => {
                return <div style={{ fontSize: '16px', fontWeight: '600', color: '#311d4f' }}>Amount</div>;
            },
            // dataIndex: 'change_amount',
            // dataIndex: 'original_value',
            align: 'center',
            width: '30%',
            render: (item, record) => (
                <div
                    style={{
                        fontWeight: '600',
                        color: '#311d4f',
                    }}
                >
                    {showAmount
                        ? `${renderSign(record?.type, record?.status_enum)} ${getNumberWithCommas(
                              getValueRecord(record) || 0,
                          )} d`
                        : '**********'}
                </div>
            ),
        },
        // {
        //     title: () => {
        // return <div style={{ fontSize: '16px', fontWeight: '600', color: '#311d4f' }}>Status</div>;
        //     },
        //     dataIndex: 'status_enum',
        //     width: '20%',
        //     align: 'center',
        //     render: (item) => (
        //         <>
        //             {item === 'PENDING' && (
        //                 <div
        //                     style={{
        //                         fontWeight: '600',
        //                         color: 'rgba(76, 111, 237, 1)',
        //                     }}
        //                 >
        //                     Processing
        //                 </div>
        //             )}
        //             {item === 'DONE' && (
        //                 <div
        //                     style={{
        //                         fontWeight: '600',
        //                         color: 'rgba(67, 181, 160, 1)',
        //                     }}
        //                 >
        //                     Success
        //                 </div>
        //             )}
        //             {item === 'CANCEL' && (
        //                 <div
        //                     style={{
        //                         fontWeight: '600',
        //                         color: 'rgba(234, 56, 56, 1)',
        //                     }}
        //                 >
        //                     Denied
        //                 </div>
        //             )}
        //         </>
        //     ),
        // },
    ];
    const columnsRose = [
        {
            title: () => {
                return <div style={{ fontSize: '16px', fontWeight: '600', color: '#311d4f' }}>Transaction</div>;
            },
            // dataIndex: 'note_admin',
            width: '30%',
            render: (item, record) => (
                <div
                    style={{
                        fontWeight: '600',
                    }}
                >
                    {record.note_admin}
                </div>
            ),
        },
        {
            title: () => {
                return <div style={{ fontSize: '16px', fontWeight: '600', color: '#311d4f' }}>Time</div>;
            },
            dataIndex: 'created_at_unix_timestamp',
            align: 'center',
            width: '30%',
            render: (item) => (
                <div
                    style={{
                        color: 'rgba(137, 137, 137, 1)',
                    }}
                >
                    {moment(item, 'x').format('HH:mm, DD/MM/YYYY')}
                </div>
            ),
        },
        {
            title: () => {
                return <div style={{ fontSize: '16px', fontWeight: '600', color: '#311d4f' }}>Amount</div>;
            },
            // dataIndex: 'change_amount',
            // dataIndex: 'original_value',
            align: 'center',
            width: '30%',
            render: (item, record) => (
                <div
                    style={{
                        fontWeight: '600',
                        color: '#311d4f',
                    }}
                >
                    {showAmount
                        ? `${renderSign(record?.type)} ${getNumberWithCommas(getValueRecord(record) || 0)} d`
                        : '**********'}
                </div>
            ),
        },
        // {
        //     title: () => {
        // return <div style={{ fontSize: '16px', fontWeight: '600', color: '#311d4f' }}>Status</div>;
        //     },
        //     dataIndex: 'status_enum',
        //     width: '20%',
        //     align: 'center',
        //     render: (item) => (
        //         <>
        //             {item === 'PENDING' && (
        //                 <div
        //                     style={{
        //                         fontWeight: '600',
        //                         color: 'rgba(76, 111, 237, 1)',
        //                     }}
        //                 >
        //                     Processing
        //                 </div>
        //             )}
        //             {item === 'DONE' && (
        //                 <div
        //                     style={{
        //                         fontWeight: '600',
        //                         color: 'rgba(67, 181, 160, 1)',
        //                     }}
        //                 >
        //                     Success
        //                 </div>
        //             )}
        //             {item === 'CANCEL' && (
        //                 <div
        //                     style={{
        //                         fontWeight: '600',
        //                         color: 'rgba(234, 56, 56, 1)',
        //                     }}
        //                 >
        //                     Denied
        //                 </div>
        //             )}
        //         </>
        //     ),
        // },
    ];

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total_item: 0,
        total_page: 0,
    });

    const handleGetHistoryTopUp = async (list, page, activeKey) => {
        try {
            setIsLoading(true);
            let historyTopUps = list;
            let final = [];
            let filter = null;
            if (activeKey === 'ROSE') {
                filter = `{"$or":[{"type": "ROSES_MONTHLY"}, {"type": "ROSES"}, {"type": "REJECTED_REQUEST_WITHDRAW"}, {"type": "APPROVED_REQUEST_WITHDRAW"},{"type": "REQUEST_WITHDRAW"}]}`;
            }
            if (activeKey === 'DISCOUNT') {
                filter = `{"type": "DISCOUNT_FOR_CLIENT_HIDDEN"}`;
            }

            const params = {
                fields: '["$all"]',
                filter: filter,
                order: '[["created_at", "DESC"]]',
                limit: pagination.limit,
                page: page,
            };

            const res = await offerAPI.getHistoryTopUpAPI(params);
            if (res.code === 200) {
                historyTopUps.push(...res.results.object.rows);
                setPagination({
                    ...pagination,
                    page: page,
                    total_item: res.results.object.count,
                    total_page: Math.ceil(res.results.object.count / pagination.limit),
                });
            }
            if (historyTopUps?.length) {
                final = [...new Map(historyTopUps.map((item) => [item['id'], item])).values()];
            }

            setHistoryTopUp(final);

            setIsLoading(false);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    };

    const handleSeeMore = () => {
        try {
            const nextPage = pagination.page + 1;
            handleGetHistoryTopUp(historyTopUp, nextPage, activeKey);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        handleGetHistoryTopUp(historyTopUp, pagination.page, activeKey);
        // eslint-disable-next-line
    }, []);

    const onChangeTabs = (key) => {
        setActiveKey(key);
        setPagination({
            page: 1,
            limit: 10,
            total_item: 0,
            total_page: 0,
        });
        handleGetHistoryTopUp([], 1, key);
    };

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangLichSuNapTien');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                <div className={cx('left_section')}>
                    <div className={cx('left_wrapper')}>
                        <div className={cx('left_container')}>
                            <Row>
                                <CardAboutMe tabIndex={{ parent: 1, children: 2 }} />
                            </Row>
                        </div>
                    </div>
                </div>
                <div className={cx('title_header')}>
                    <Row className={cx('title_header_row')}>
                        <p className={cx('title')}>
                            <LeftOutlined
                                onClick={() => navigate(config.routes.personalPage)}
                                className={cx('btn_back')}
                            />{' '}
                            Transaction history
                        </p>
                    </Row>
                </div>
                <div className={cx('right_section')}>
                    <Row className={cx('name_page')}>
                        <Col xs={14}>Transaction History</Col>
                        <Col xs={10}>
                            <Row justify="end">
                                {showAmount ? (
                                    <EyeOutlined
                                        className={cx('icon_show_amount')}
                                        onClick={() => setShowAmount(false)}
                                    />
                                ) : (
                                    <EyeInvisibleOutlined
                                        className={cx('icon_show_amount')}
                                        onClick={() => setShowAmount(true)}
                                    />
                                )}
                            </Row>
                        </Col>
                    </Row>
                    <div className={cx('right_container')}>
                        <div className={cx('wallet')}>
                            <Wallet showAmount={showAmount}></Wallet>
                            <Divider style={{ borderTop: '5px solid rgba(0,0,0,.06)' }} />
                        </div>

                        <TabsContainer>
                            <Tabs defaultActiveKey={activeKey} onChange={onChangeTabs}>
                                <TabPane tab="All" key="">
                                    {isLoading ? (
                                        <Row justify="center" className={cx('spin')}>
                                            <Spin />
                                        </Row>
                                    ) : (
                                        <div className={cx('table_container')}>
                                            <Content
                                                isLoading={isLoading}
                                                columns={columnsDeposit}
                                                history={historyTopUp}
                                            />
                                            {pagination.page < pagination.total_page && (
                                                <Row justify="center" style={{ marginTop: '30px' }}>
                                                    <div className={cx('btn_see_more')} onClick={handleSeeMore}>
                                                        see more
                                                    </div>
                                                </Row>
                                            )}
                                        </div>
                                    )}
                                </TabPane>
                                <TabPane tab="Rose" key="ROSE">
                                    {isLoading ? (
                                        <Row justify="center" className={cx('spin')}>
                                            <Spin />
                                        </Row>
                                    ) : (
                                        <div className={cx('table_container')}>
                                            <Content
                                                isLoading={isLoading}
                                                columns={columnsRose}
                                                history={historyTopUp}
                                            />
                                            {pagination.page < pagination.total_page && (
                                                <Row justify="center" style={{ marginTop: '30px' }}>
                                                    <div className={cx('btn_see_more')} onClick={handleSeeMore}>
                                                        see more
                                                    </div>
                                                </Row>
                                            )}
                                        </div>
                                    )}
                                </TabPane>
                                {/* <TabPane tab="Offers" key="DISCOUNT">
                                    {isLoading ? (
                                        <Row justify="center" className={cx('spin')}>
                                            <Spin />
                                        </Row>
                                    ) : (
                                        <div className={cx('table_container')}>
                                            <Content
                                                isLoading={isLoading}
                                                columns={columnsDeposit}
                                                history={historyTopUp}
                                            />
                                            {pagination.page < pagination.total_page && (
                                                <Row justify="center" style={{ marginTop: '30px' }}>
                                                    <div className={cx('btn_see_more')} onClick={handleSeeMore}>
                                                        see more
                                                    </div>
                                                </Row>
                                            )}
                                        </div>
                                    )}
                                </TabPane> */}
                            </Tabs>
                        </TabsContainer>
                    </div>
                </div>
            </div>
        </div>
    );
};

const Content = ({ isLoading, columns, history }) => {
    return (
        <div>
            {/* <Divider style={{ borderTop: '10px solid rgba(0,0,0,.06)' }} /> */}
            <Row justify="center">
                <ConfigProvider renderEmpty={() => <EmptyForm />}>
                    <TableCustom>
                        <Table
                            className={cx('table')}
                            columns={columns}
                            dataSource={history}
                            pagination={false}
                            loading={isLoading}
                            scroll={{ y: 700 }}
                        />
                    </TableCustom>
                    <div className={cx('mobile_view')}>
                        {history?.length ? (
                            <>
                                {history?.map((item) => {
                                    return (
                                        <Row className={cx('record_mobile')}>
                                            <Col xs={16}>
                                                <Row className={cx('title')}>{item.note_admin}</Row>
                                                <Row className={cx('time')}>
                                                    {moment(item?.created_at_unix_timestamp, 'x').format(
                                                        'HH:mm, DD/MM/YYYY',
                                                    )}
                                                </Row>
                                            </Col>
                                            <Col xs={8}>
                                                <Row className={cx('value')} justify="end">
                                                    {`${renderSign(item?.type)} ${getNumberWithCommas(
                                                        item.original_value || 0,
                                                    )} d`}
                                                </Row>
                                            </Col>
                                        </Row>
                                    );
                                })}
                            </>
                        ) : (
                            <Row justify="center">
                                <div className={cx('no_service')}>
                                    <img src={SVGS.IconNoService} alt="" />
                                    <span>No transactions</span>
                                </div>
                            </Row>
                        )}
                    </div>
                </ConfigProvider>
            </Row>
        </div>
    );
};

export default HistoryTopUp;
